import React from "react";
import {Cookies} from 'react-cookie';

const cookies = new Cookies();

export const setCookie = (name : string, value : string) =>
{return cookies.set(name, value)}
export const getCookie = (name : string) =>
{return cookies.get(name)}